<template>
  <div class="rounded border px-5 py-4" :class="resolved ? 'border-secondary-300 bg-gray-50' : 'border-red-300 bg-red-50'">
    <div class="flex flex-wrap items-center gap-3">
      <span v-if="!resolved" class="so-livedot"></span>
      <span class="text-xs font-bold uppercase tracking-wide" :class="resolved ? 'text-gray-500' : 'text-red-700'">{{ label }}</span>
      <SoChip :tone="resolved ? 'plain' : 'live'">{{ shortId }}</SoChip>
      <div class="ml-auto flex items-center gap-4">
        <span v-if="!resolved" class="font-mono text-2xl tabular-nums text-red-700">{{ elapsedSince(event.raisedAt || event.createdAt) }}</span>
        <span v-else class="text-sm text-gray-500 font-mono">{{ dateTime(event.raisedAt || event.createdAt) }}</span>
      </div>
    </div>
    <div class="mt-3">
      <div class="text-xl font-bold font-serif text-gray-800">{{ event.category.name }}</div>
      <div v-if="subtitle" class="text-sm text-gray-600 mt-1">{{ subtitle }}</div>
      <div v-if="event.raisedAt && event.raisedAt !== event.createdAt && !resolved" class="text-xs text-yellow-800 mt-1">
        <BaseIcon icon="clock" class="mr-1" />{{ $t("securone.event.raised_offline", { time: dateTime(event.raisedAt) }) }}
      </div>
    </div>
    <div v-if="showInstruction && event.category.instruction" class="mt-4 rounded border-l-4 bg-white px-4 py-3" :class="resolved ? 'border-secondary-300' : 'border-red-400'">
      <div class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">{{ instructionLabel }}</div>
      <div class="text-base leading-relaxed text-gray-800" :class="{ 'font-semibold': emphasise }">{{ event.category.instruction }}</div>
    </div>
    <slot />
  </div>
</template>

<script>
import SoChip from "./SoChip.vue";
import { tickerMixin } from "../securone.helpers";

// Red is reserved for a live event; a resolved one gets grey chrome. Read-only:
// the console never resolves an event (plan §11.3).
export default {
  name: "AlarmHeader",
  components: { SoChip },
  mixins: [tickerMixin],
  props: {
    event: { type: Object, required: true },
    label: { type: String, required: true },
    subtitle: { type: String, default: "" },
    showInstruction: { type: Boolean, default: true },
    instructionLabel: { type: String, default: "" },
    emphasise: { type: Boolean, default: false },
  },
  computed: {
    resolved() {
      return this.event.status === "resolved";
    },
    shortId() {
      return "EV-" + String(this.event._id).slice(-6).toUpperCase();
    },
  },
};
</script>
